import { io } from 'socket.io-client';
import { apiList } from '../api/apiList';

const resolveSocketUrl = () => {
  const configuredUrl = process.env.REACT_APP_SOCKET_URL?.trim();

  if (configuredUrl) {
    return configuredUrl;
  }

  return apiList.baseUrl.replace(/\/api\/v1\/?$/, '');
};

const SOCKET_URL = resolveSocketUrl();

let socketInstance = null;

export const getSocket = () => {
  if (!socketInstance) {
    socketInstance = io(SOCKET_URL, {
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1500,
      transports: ['websocket', 'polling'],
    });

    socketInstance.on('connect_error', (error) => {
      console.error('Socket connection failed:', {
        url: SOCKET_URL,
        message: error.message,
        description: error.description,
        context: error.context,
      });
    });
  }

  return socketInstance;
};

export const connectSocket = () => {
  const socket = getSocket();

  if (!socket.connected) {
    socket.connect();
  }

  return socket;
};
